import React from 'react';
import { Monitor, Landmark, HeartPulse, ShoppingBag, Users, Smartphone, Factory } from 'lucide-react';

const Industries = ({
    title = "Industries We Serve",
    description = "Trusted by organizations that value secure and compliant hiring.",
    industries = [
        { icon: Monitor, title: "IT & Technology" },
        { icon: Landmark, title: "Banking & Finance" },
        { icon: HeartPulse, title: "Healthcare & Pharma" },
        { icon: ShoppingBag, title: "Retail & E-commerce" },
        { icon: Users, title: "Staffing & Recruitment" },
        { icon: Smartphone, title: "Gig & Platform Economy" },
        { icon: Factory, title: "Manufacturing & Logistics" },
    ]
}) => {

    return (
        <section className="py-24 bg-white relative">
            <div className="container-padding-x mx-auto px-4 max-w-6xl">
                <div className="mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-[#3A3D46] mb-4">
                        {title}
                    </h2>
                    <p className="text-[#3A3D46] text-lg max-w-2xl">
                        {description}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {industries.map((item, index) => (
                        <div key={index} className="bg-white border border-gray-100 rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center group cursor-default">
                            <div className="mb-6 opacity-80 group-hover:opacity-100 transition-opacity transform group-hover:scale-110 duration-300">
                                <div className="p-3 bg-blue-50 rounded-lg">
                                    <item.icon size={32} className="text-[#168DEF]" />
                                </div>
                            </div>
                            <h3 className="text-[#3A3D46] font-semibold text-sm md:text-base">
                                {item.title}
                            </h3>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Industries;
